import {
  Directive,
  EmbeddedViewRef,
  OnInit,
  Renderer2,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

@Directive({
  standalone: true,
  selector: '[boelsInjectIcon]',
})
export class InjectIconDirective implements OnInit {
  private viewContainerRef = inject(ViewContainerRef);
  private renderer = inject(Renderer2);

  faCheck = faCheck;

  ngOnInit() {
    this.getListItems().forEach((target: HTMLElement) => {
      this.createComponent(target);
    });
  }

  getListItems(): HTMLElement[] {
    return Array.from(
      this.viewContainerRef.element.nativeElement.getElementsByTagName('li'),
    );
  }

  createComponent(target: HTMLElement): void {
    const componentRef = this.viewContainerRef.createComponent(FaIconComponent);
    componentRef.instance.icon = this.faCheck;
    componentRef.instance.render();
    const component = componentRef.hostView as EmbeddedViewRef<FaIconComponent>;
    this.renderer.insertBefore(
      target,
      component.rootNodes[0],
      target?.firstChild,
    );
  }
}
